export function hasWebpSupport() {
    /* modified version of https://github.com/Modernizr/Modernizr/blob/400db4043c22af98d46e1d2b9cbc5cb062791192/feature-detects/img/webp.js */
    return new Promise((resolve) => {
        const supportedOptions = {};
        const webpTests = [{
            'uri': 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=',
            'name': 'webp'
        }, {
            'uri': 'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==',
            'name': 'webpalpha'
        }, {
            'uri': 'data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
            'name': 'webpanimation'
        }, {
            'uri': 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=',
            'name': 'webplossless'
        }];

        let webp = webpTests.shift();

        function test(name, uri, cb) {
            const image = new Image();
    
            function addResult(event) {
                // if the event is from 'onload', check the see if the image's width is
                // 1 pixel (which indicates support). otherwise, it fails          
                supportedOptions[name] = event && event.type === 'load' ? image.width === 1 : false;
    
                if (cb) {
                    cb(event);
                }
                
                // last callback
                if (Object.keys(supportedOptions).length === webpTests.length + 1) {
                    const result = supportedOptions.webp && supportedOptions.webpalpha && supportedOptions.webpanimation && supportedOptions.webplossless;
                    resolve(result);
                }
            }
    
            image.onerror = addResult;
            image.onload = addResult;
    
            image.src = uri;
        }
        
        // test for webp support in general
        test(webp.name, webp.uri, function(e) {
            // if the webp test loaded, test everything else.
            if (e && e.type === 'load') {
                for (let i = 0, len = webpTests.length; i < len; i++) {
                    test(webpTests[i].name, webpTests[i].uri);
                }
            } else {
                resolve(false);
            }
        }); 
    });        
}